import fetch from 'cross-fetch';

let baseApiUrl = '';
export const initIamApi = (settings: { apiDomain: string }): void => {
  const currentDomain = typeof window !== 'undefined' ? window.location.hostname : '';
  if (currentDomain.indexOf('iam.kaplanlearn.com') === -1 && currentDomain !== 'localhost') {
    baseApiUrl = `${window.location.origin}/iam/api`;
  } else {
    baseApiUrl = `https://${settings.apiDomain}`;
  }
};

export const ping = async (): Promise<boolean> => {
  try {
    const response = await fetch(`${baseApiUrl}/ping`);
    const healthy = await response.text();
    return response.status === 200 && healthy === 'healthy';
  } catch {
    return false;
  }
};

export const requestTransfer = async (username: string, password: string): Promise<void> => {
  const response = await fetch(`${baseApiUrl}/requestTransfer`, {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
  const { ok } = response;

  if (!ok) {
    throw new Error(await response.text());
  }
};

export const validateUsername = async (personId: number, username: string): Promise<void> => {
  const response = await fetch(`${baseApiUrl}/validateUsername`, {
    method: 'POST',
    body: JSON.stringify({ personId, username }),
  });
  const { ok } = response;

  if (!ok) {
    throw new Error(await response.text());
  }
};

export default {
  requestTransfer,
  validateUsername,
};
